import * as p from '@clack/prompts'
import type { SchemaPromptContext } from '@cli-types/next-adapter/commands.js'
import { cancelIfNeeded } from './cancel-if-needed.js'

export async function promptSelectValue<T extends string>(
  context: SchemaPromptContext,
  message: string,
  options: Array<{ value: T; label: string }>,
  initialValue?: T
): Promise<T> {
  const value = await p.select<T>({
    message,
    options: options as never,
    initialValue
  })
  return cancelIfNeeded(context, value) as T
}
